import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumb = ({ items }) => {
  const location = useLocation();
  
  // Auto-generate breadcrumbs from path if items not provided
  const generateBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    
    return [
      { name: 'Dashboard', href: '/dashboard', icon: Home },
      ...pathnames.slice(1).map((name, index) => {
        const href = `/${pathnames.slice(0, index + 2).join('/')}`;
        return {
          name: name.charAt(0).toUpperCase() + name.slice(1),
          href,
        };
      }),
    ];
  };

  const breadcrumbs = items || generateBreadcrumbs();

  return (
    <nav className="flex mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbs.map((item, index) => (
          <li key={item.href} className="flex items-center">
            {index > 0 && (
              <ChevronRight className="h-4 w-4 text-gray-400 mx-2" />
            )}
            
            {index === breadcrumbs.length - 1 ? (
              // Current page - not a link
              <span className="flex items-center text-sm font-medium text-gray-500">
                {item.icon && <item.icon className="h-4 w-4 mr-1" />}
                {item.name}
              </span>
            ) : (
              // Link to other pages
              <Link
                to={item.href}
                className="flex items-center text-sm font-medium text-gray-700 hover:text-primary-600 transition-colors"
              >
                {item.icon && <item.icon className="h-4 w-4 mr-1" />}
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;